<template>
    <Line v-if="loaded" id="line" :data="lineData" :options="lineOpts" :key="key" />
</template>

<script lang="ts">
import LineComponent from './LineComponent';
export default LineComponent;
</script>